import {
    styled,
    Typography,
    SIDEBAR_SPACING_MOBILE,
    SIDEBAR_WIDTH,
} from "@l2r-front/l2r-ui"

export const PanelContent = styled("div")(() => ({
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    overflow: "hidden",
    width: "100%",
}))

export const Container = styled("div")(() => ({
    height: "100%",
    width: "100%",
    overflowY: "auto",
}))

export const GridContainer = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette["surfaces/surface-clair"].main,
    columnGap: theme.spacing(11),
    display: "grid ",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr 1fr 1fr",
    height: "100%",
    padding: theme.spacing(11),
    rowGap: theme.spacing(11),
    width: "100%",
    minHeight: 800,
}))

export const FlexContainer = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette["surfaces/surface-clair"].main,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(SIDEBAR_SPACING_MOBILE, SIDEBAR_SPACING_MOBILE, 0, SIDEBAR_SPACING_MOBILE),
    width: "100%",
}))

export const NetworkName = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    padding: theme.spacing(5, 10, 0, 15),
}))

export const Wrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 8, 4),
}))

export const NetworkLength = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(2),
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "16px",
    fontWeight: "bold",
}))

export const Sidebar = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette["surfaces/surface-variation"].main,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: SIDEBAR_WIDTH,
}))

export const Scrollable = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(6),
    height: "fit-content",
    paddingBottom: theme.spacing(6),
    overflowY: "auto",
    width: "100%",
}))

export const PanelWrapper = styled("div")(({ theme }) => ({
    overflowY: "auto",
    height: "100%",
    width: "100%",
    padding: theme.spacing(10),
}))